import { render, staticRenderFns } from "./CustomerSearch.vue?vue&type=template&id=9360de60"
import script from "./CustomerSearch.vue?vue&type=script&lang=ts"
export * from "./CustomerSearch.vue?vue&type=script&lang=ts"
import style0 from "./CustomerSearch.vue?vue&type=style&index=0&id=9360de60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports